import { render, staticRenderFns } from "./pre_tan_one.vue?vue&type=template&id=c657351c&scoped=true"
import script from "./pre_tan_one.vue?vue&type=script&lang=js"
export * from "./pre_tan_one.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c657351c",
  null
  
)

export default component.exports